/**
 * The constant type for the adjust volume action.
 *
 * @type {string}
 */
export const ADJUST_VOLUME = 'ADJUST_VOLUME';
